import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";





'use strict';


var helpers = {

  dataAttrib: function(obj) {
    var str = "";
    for (var key in obj) {

      if (typeof obj[key] === "object") {

        str += "data-" + key + "='" + JSON.stringify(obj[key], null, 0) + "' ";
      } else {
        str += "data-" + key + "='" + obj[key] + "' ";
      }

    }
    return str;

  },





  parseJSON: function(data, options) {
    return options.fn(JSON.parse(data));
  }

};

class helpersData {
  static register(Handlebars) {

    for (var helper in helpers) {
      if (helpers.hasOwnProperty(helper)) {
        Handlebars.registerHelper(helper, helpers[helper]);
      }
    }
  }
}

module.exports = helpersData;